import React, {Component} from 'react';

class Access extends Component {
    permissions = window.roles;

    render() {
        // console.debug(this.props.permission, this.permissions[this.props.permission]);
        let authorized =
            (this.permissions &&
                this.props.permission &&
                this.permissions[this.props.permission] &&
                this.permissions[this.props.permission].indexOf(
                    window.user.admin.group.id
                ) !== -1) ||
            this.props.permission === 'all';

        if(window.roles)
            if(Object.keys(window.roles).length==0)authorized=true


        return authorized ? <>{this.props.children}</> : <></>;
    }

    verify = (permission) => {
        this.permissions = window.roles;
        // return true
        // if(window.permissions.length>0) return true
        if (permission !== 'all') console.debug(this.permissions);
        return (
            (this.permissions &&
                permission &&
                this.permissions[permission] &&
                this.permissions[permission].indexOf(window.user.admin.group.id) !==
                -1) ||
            permission === 'all'
        );
    };
}

export default Access;
